export const CIRCLE_DIAMETER = 50;
